import utilCSS from './utilityStyles.css?raw'
export const utilityStyles = new CSSStyleSheet()
utilityStyles.replace(utilCSS)